import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import logger from '../../utils/logger';

interface RouteProps {
  component: JSX.Element;
}

/**
 * A custom navigation route component for securing components which should be visible only to authenticated users
 */
export default function AuthRoute({ component }: RouteProps) {
  const { isAuthenticated } = useAuth();
  useEffect(() => {
    logger.i({ isAuthenticated });
  }, [isAuthenticated]);
  const Page = () => component;
  return isAuthenticated ? <Page /> : <Navigate to="/signin" />;
}
